var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79292 1.2674C7.75808 -0.450158 11.4028 -0.420138 14.3401 1.34603C17.2486 3.14818 19.0162 6.36447 18.9999 9.82431C18.9321 13.2614 17.0366 16.4924 14.6673 18.99C13.2998 20.4381 11.77 21.7185 10.1091 22.8052C9.93809 22.9038 9.75073 22.9698 9.5563 23C9.36917 22.9921 9.18693 22.9369 9.02602 22.8396C6.49044 21.2068 4.26595 19.1225 2.45959 16.6871C0.948083 14.6542 0.0893468 12.1981 0 9.65245L0.00676701 9.28211C0.13018 5.95923 1.93365 2.92361 4.79292 1.2674ZM10.7313 6.81175C9.52588 6.30096 8.13613 6.57847 7.21093 7.51471C6.28573 8.45094 6.00759 9.86122 6.50636 11.0871C7.00514 12.3129 8.18246 13.1125 9.48861 13.1125C10.3443 13.1186 11.1668 12.7769 11.773 12.1636C12.3791 11.5502 12.7184 10.7162 12.7154 9.84722C12.72 8.52087 11.9367 7.32254 10.7313 6.81175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 27C13.0899 27 16 26.3284 16 25.5C16 24.6716 13.0899 24 9.5 24C5.91015 24 3 24.6716 3 25.5C3 26.3284 5.91015 27 9.5 27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSvg);
export default __webpack_public_path__ + "static/media/locationSvg.82e48a1e18ad39168b85bb6218dd13ee.svg";
export { ForwardRef as ReactComponent };